// @flow

// DEPRECATED // use dataTypes/org/types
export const SCHOOL: 'school' = 'school';
export const PRESCHOOL: 'preschool' = 'preschool';
export const ENTERPRISE: 'enterprise' = 'enterprise';
export const HIGH_SCHOOL: 'high_school' = 'high_school';
export const UNKNOWN: 'unknown' = 'unknown';
